import { Nav, NavItem, NavLink } from 'reactstrap';
import * as React from 'react';
import { useScrollToActive } from '../../hooks';
import './OnboardingNavbar.scss';
import { RefMap } from '../../types';
import { scrollIntoView } from '../../utils';
import OnboardingProductlist from './OnboardingProductList';

type OBSectionNavItemProps = {
  section: string;
  activeItem: string;
  onClick: React.MouseEventHandler;
};

const OBSectionNavItem: React.FunctionComponent<OBSectionNavItemProps> = ({
  section,
  activeItem,
  onClick,
}) => (
  <NavItem className={activeItem === section ? 'active-item link' : 'link'}>
    <NavLink data-section={section} className="ob" onClick={onClick}>
      {section}
    </NavLink>
  </NavItem>
);

type Props = {
  refMap: RefMap;
  isOnboardingInProgress: boolean;
};

const OnboardingNavBar = (props: Props) => {
  const { refMap, isOnboardingInProgress } = props;

  const { activeItem, setActiveItem } = useScrollToActive(refMap);

  const onClick = React.useCallback(
    (e: React.MouseEvent<HTMLAnchorElement>) => {
      const section = e.currentTarget.dataset.section;
      if (section) {
        setActiveItem(section);
        const ref = refMap.get(section);
        if (ref?.current) {
          scrollIntoView(ref.current);
        }
      }
    },
    [refMap, setActiveItem],
  );

  return (
    <div className="ob-nav-bar">
      <div className="pb-4">
        <OnboardingProductlist />
      </div>
      {isOnboardingInProgress && (
        <div className="ob-toc">
          <Nav vertical>
            {Array.from(refMap.entries()).map(([section]) => (
              <OBSectionNavItem
                key={section}
                section={section}
                activeItem={activeItem}
                onClick={onClick}
              />
            ))}
          </Nav>
        </div>
      )}
    </div>
  );
};

export default OnboardingNavBar;
